import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CaeImportErrorCollector } from '@configuration/assistants/cae-assistant/cae-import-error-collector';
import { CaeResultComponent } from '@configuration/assistants/cae-assistant/cae-result/cae-result.component';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-csv-result',
  imports: [
    CaeResultComponent,
    TranslateModule,
  ],
  templateUrl: './csv-result.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsvResultComponent {

  public caeImportErrorCollector!: CaeImportErrorCollector;

  constructor(
    private bsModalRef: BsModalRef,
  ) {
  }

  public close() {
    this.bsModalRef.hide();
  }
}
